module.exports = __webpack_public_path__ + "static/media/shape.9d686c17.png";